import React, { useState } from 'react';
import CourseCard from '../CourseCard';
import Carousel from '../Carousel';
import styles from 'LearningManager/styles/QuickSetup.module.scss';
import { Icon } from 'Components';
import CourseDetailModal from '../CourseDetailModal';
import { courseDetailMockData } from 'LearningManager/constants/createAssignment.constant';

interface Props {
	id?: string;
	title: string;
	duration: string;
	description: string;
	courses: any[];
}

const LearningSection: React.FC<Props> = ({
	id,
	title,
	duration,
	description,
	courses
}) => {
	const [showDetails, setShowDetails] = useState(false);
	const [detailActivityId, setDetailActivityId] = useState<
		number | undefined
	>(undefined);

	return (
		<div id={id} className={styles.learningSection}>
			<div className={styles.sectionHeader}>
				<div className={styles.headingContainer}>
					<Icon type="pathIcon" role="img" />
					<div>{title}</div>
					<div className={styles.duration}>
						<Icon type="clockIcon" role="img" /> {duration}
					</div>
				</div>
				<div className={styles.description}>{description}</div>
			</div>

			<Carousel
				data={courses}
				itemsPerPage={4}
				overlayControls
				renderItem={(course, position) => (
					<CourseCard
						key={course.id}
						course={course}
						index={position + 1}
						onClick={() => {
							setDetailActivityId(course.id);
							setShowDetails(true);
						}}
						hideMandatoryCover
					/>
				)}
			/>

			<CourseDetailModal
				visible={showDetails}
				onClose={() => setShowDetails(false)}
				activityId={detailActivityId}
				{...courseDetailMockData}
			/>
		</div>
	);
};

export default LearningSection;
